import { render, staticRenderFns } from "./ItemGroupForm.vue?vue&type=template&id=4b1ad47b&scoped=true"
import script from "./ItemGroupForm.vue?vue&type=script&lang=js"
export * from "./ItemGroupForm.vue?vue&type=script&lang=js"
import style0 from "./ItemGroupForm.vue?vue&type=style&index=0&id=4b1ad47b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1ad47b",
  null
  
)

export default component.exports